/**
 * @generated SignedSource<<972d95514361419019788660c87a812a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GeneralTab_hydrant$data = {
  readonly id: string;
  readonly currentMeasurements: {
    readonly " $fragmentSpreads": FragmentRefs<"MeasurementsSection_currentMeasurements">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"IdentificationSection_asset" | "HistorySection_asset" | "ManufacturingSection_asset" | "DetailsSection_hydrant">;
  readonly " $fragmentType": "GeneralTab_hydrant";
};
export type GeneralTab_hydrant = GeneralTab_hydrant$data;
export type GeneralTab_hydrant$key = {
  readonly " $data"?: GeneralTab_hydrant$data;
  readonly " $fragmentSpreads": FragmentRefs<"GeneralTab_hydrant">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GeneralTab_hydrant",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IdentificationSection_asset"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HistorySection_asset"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ManufacturingSection_asset"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DetailsSection_hydrant"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeasurementConnection",
      "kind": "LinkedField",
      "name": "currentMeasurements",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MeasurementsSection_currentMeasurements"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Hydrant",
  "abstractKey": null
};

(node as any).hash = "7e4ba59745bcfe3b41337ea6a0a0007b";

export default node;
